import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';
import { registerServiceWorker } from '@/lib/pwa';

const container = document.getElementById('root');
if (!container) {
  throw new Error('root container missing');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
